import { DATE_FORMAT, DATE_FORMAT_BACKEND_STRING, DATE_TIME_FORMAT, } from './constants';
import { format, getDate, getMonth, getYear, isDate, isValid } from 'date-fns';
export const formatDate = (date) => date.format(DATE_FORMAT);
export const formatStarjackDate = (date) => {
    if (isValid(date)) {
        return format(date, 'dd.MM.yyyy');
    }
    return null;
};
export const formatDateWithTime = (date) => date.format(`${DATE_TIME_FORMAT} `);
export const formatStarjackDateToBackendString = (date) => {
    if (!date)
        return undefined;
    return format(date, DATE_FORMAT_BACKEND_STRING);
};
export const convertDateFromDateArray = (dateArray) => {
    if (!Array.isArray(dateArray)) {
        return null;
    }
    const [year, month, day, hours = 0, minutes = 0] = dateArray;
    const timeZoneOffsetHours = new Date().getTimezoneOffset() / 60;
    if (hours === 0 && minutes === 0) {
        return new Date(year, month - 1, day);
    }
    else {
        return new Date(year, month - 1, day, hours - timeZoneOffsetHours, minutes);
    }
};
export const convertDateArrayFromDate = (date) => {
    if (!isDate(date))
        return [];
    return [getYear(date), getMonth(date) + 1, getDate(date)];
};
export const convertIsoDateFromDate = (date) => {
    if (!isDate(date))
        return '';
    return format(date, 'yyyy-MM-dd');
};
export const convertIsoDateToDate = (isoDate) => {
    if (!isoDate)
        return null;
    return new Date(isoDate);
};
// TODO: as Date there is bad type safety, better throw an error or something, i added this due to strict ts mode there, also moved it in here from types because is was a circular dependency
export const convertStarjackDateRangeToFrontend = (dateRange) => ({
    from: convertDateFromDateArray(dateRange.from),
    to: convertDateFromDateArray(dateRange.to),
});
